export const sortPackagesDataByDateReversed = arr => {
  const sortedArr = arr.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(a.updatedAt) - new Date(b.updatedAt)
  })
  // console.log("SORTED=>>>>", sortedArr)
  return sortedArr
}

export const sortPackagesDataByDateArrivedReversed = arr => {
  const sortedArr = arr.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(a.createdAt) - new Date(b.createdAt)
  })
  // console.log("SORTED=>>>>", sortedArr)
  return sortedArr
}

export const sortPackagesDataByDatePaid = arr => {
  const sortedArr = arr.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(a.datePayed) - new Date(b.datePayed)
  })
  // console.log("SORTED=>>>>", sortedArr)
  return sortedArr
}

export const sortPackagesDataByDateArrivedReg = arr => {
  const sortedArr = arr.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b.createdAt) - new Date(a.createdAt)
  })
  // console.log("SORTED=>>>>", sortedArr)
  return sortedArr
}

export const sortPackagesDataByEmail = arr => {
  const sortedArr = arr.sort(function (a, b) {
    if (a.costumer_Email < b.costumer_Email) return -1
    if (a.costumer_Email > b.costumer_Email) return 1
    return 0
  })
  // console.log("SORTED=>>>>", sortedArr)
  return sortedArr
}
